/**
 * @generated SignedSource<<4cf938a19766e09936413a424236fdf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "proposeNominatedTrade",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProposeNominatedTradeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProposeNominatedTradeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4defdfced0eeb1cc83176449bfa80a60",
    "id": null,
    "metadata": {},
    "name": "ProposeNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation ProposeNominatedTradeMutation(\n  $input: NominatedTradeRuleProposal!\n) {\n  proposeNominatedTrade(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "d14c3b5abd5a39255946688bbbb10a0d";

module.exports = node;
